import * as React from 'react'
import { IPaymentSourceResponseDTO } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import PaymentSourceItem from './PaymentSourceItem'

interface IPaymentSourceListProps {
  riderId: string
  paymentSources: IPaymentSourceResponseDTO[]
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
  updateDefaultPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
}

class PaymentSourceList extends React.Component<IPaymentSourceListProps> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { paymentSources } = this.props
    return (
      <div style={{ flex: 1 }}>
        <div className='mt3'>
          <p className='h5 font-grey2 bold'>{UIMessages.common.savedPaymentMethod}</p>
        </div>
        {paymentSources.map((item, i) => (
          <div key={`tmli-${i}`}>
            {<PaymentSourceItem remove={this.remove} makeDefault={this.makeDefault} paymentSource={item} />}
          </div>
        ))}
        {paymentSources.length === 0 && (
          <div className='payment-source-item default'>
            <div className='font-grey2 bold h5 pb2 pt2 center'>No Existing Payment Method Yet</div>
          </div>
        )}
      </div>
    )
  }

  private makeDefault = (source: IPaymentSourceResponseDTO) => {
    this.props.updateDefaultPaymentSource(source.id, this.props.riderId)
  }

  private remove = (source: IPaymentSourceResponseDTO) => {
    const { riderId } = this.props
    this.props.removeRiderPaymentSource(source.id, this.props.riderId)
  }
}

export default PaymentSourceList



// WEBPACK FOOTER //
// ./src/components/riders/common/PaymentSourceList.tsx